import { render } from "./BrandDiva.vue?vue&type=template&id=7c46f79a"
import script from "./BrandDiva.vue?vue&type=script&lang=ts"
export * from "./BrandDiva.vue?vue&type=script&lang=ts"

import "./BrandDiva.vue?vue&type=style&index=0&id=7c46f79a&lang=scss"
script.render = render

export default script